module.exports = __webpack_public_path__ + "img/111.5d2208d1.webp";